import React from "react";
import Heading from "./partials/Heading";
import "./About.scss";
import {
  selectAuthorAboutDesc,
  selectAuthorDislayPic,
  selectAuthorName,
  selectAuthorTitle,
  selectToolsForCategoryID,
  toolCategoriesSelectors,
  ToolCategory,
  useAppSelector,
  selectAuthorResumeHref,
} from "../store";
import marked from "marked";
import sanitizeHtml from "sanitize-html";
import { motion } from "framer-motion";
import { pageVariants } from "../App";

interface IntroductionProps {}
function Introduction(props: IntroductionProps) {
  const authorName = useAppSelector(selectAuthorName);
  const authorTitle = useAppSelector(selectAuthorTitle);
  const authorDP = useAppSelector(selectAuthorDislayPic);
  const aboutText = useAppSelector(selectAuthorAboutDesc);

  return (
    <div className="introduction">
      <div className="profile">
        <div className="profile-circle">
          <img
            className="profile-picture"
            src={authorDP}
            alt="author profile"
          />
        </div>

        <div className="name">{authorName}</div>
        <div className="title">{authorTitle}</div>
      </div>
      <div
        className="about-text"
        dangerouslySetInnerHTML={{
          __html: sanitizeHtml(marked(aboutText ?? "")),
        }}
      ></div>
    </div>
  );
}

function ToolSet({ id, name }: ToolCategory) {
  const tools = useAppSelector((state) => selectToolsForCategoryID(state, id));

  return (
    <>
      {tools && tools.length && (
        <div className="toolset">
          <div className="tool-category">{name}</div>
          {tools.map((item, index) => {
            return (
              <div className="tool" key={index}>
                {item.name}
              </div>
            );
          })}
        </div>
      )}
    </>
  );
}

interface StackInfoProps {}
function StackInfo(pros: StackInfoProps) {
  const toolCategs = useAppSelector(toolCategoriesSelectors.selectAll);
  return (
    <div className="stack-info">
      <div className="title">SOME OF THE TOOLS THAT I USE</div>
      <div className="tools-container">
        {toolCategs.map((item, index) => {
          return <ToolSet key={index} {...item} />;
        })}
      </div>
    </div>
  );
}

function Resume() {
  const resumeHref = useAppSelector(selectAuthorResumeHref);

  return (
    <div className="resume">
      You can download my resume{" "}
      <a href={resumeHref} target="_blank" rel="noreferrer noopener">
        here
      </a>
      .
    </div>
  );
}

interface AboutProps {}
function About(props: AboutProps) {
  return (
    <motion.div
      className="about-page"
      variants={pageVariants}
      initial="initial"
      animate="in"
      exit="out"
    >
      <Heading>About</Heading>
      <Introduction />
      <Resume />
      <StackInfo />
    </motion.div>
  );
}
export { About as default };
